import React, { FormEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/auth'
import { useClient } from '../../hooks/client'
import { parseError } from '../../services/api'

import { SignInForm } from 'src/components/formLogin/input-form'

import appStore from 'src/assets/product-config/app-store.png'
import backgroundMobile from 'src/assets/product-config/backgroud-mobile.png'
import background2 from 'src/assets/product-config/background-signin-2.png'
import background from 'src/assets/product-config/background-signin.png'
import android from 'src/assets/product-config/google-play.png'
import loginBlocks from 'src/assets/product-config/login-blocks.png'
import logoBlack from 'src/assets/product-config/logo-black.png'
import logo from 'src/assets/product-config/logo-white.png'

import './style.css'

export const SignIn: React.FC = () => {
  const { client } = useClient()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigation = useNavigate()
  const { signIn, account, user } = useAuth()

  const [document, setDocument] = useState('')
  const [password, setPassword] = useState('')
  const [isKeyboardVisible, setKeyboardVisible] = useState(false)
  const [virtualKeyboardDocument, setVirtualKeyboardDocument] =
    useState<string>('')
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  //useEffect(() => {
  // Limpar o localStorage imediatamente quando o componente é montado
  // localStorage.clear();
  //}, []); // O array vazio assegura que o efeito só é executado uma vez, ao montar o componente

  const handleDocumentClick = () => {
    setKeyboardVisible(true)
  }

  // const handleDocumentBlur = () => {
  //   setKeyboardVisible(false);
  // };

  const handlePasswordVisibility = () => {
    setIsPasswordVisible((state) => !state)
  }

  const handleKeyboardClose = () => {
    setKeyboardVisible(false)
  }

  const handleKeyboardKeyPress = (key: string) => {
    setDocument(document + key)
  }

  const handleOutsideClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    // Verifica se o clique foi fora do ModalContainer
    if (event.target === event.currentTarget) {
      // Fecha o modal
      handleKeyboardClose()
    }
  }

  const handleOutsideClickClose = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    // Verifica se o clique foi fora do ModalContainer
    if (event.target === event.currentTarget) {
      // Fecha o modal
      handleKeyboardClose()
    }
  }

  useEffect(() => {
    if (account) {
      navigation('/')
    }

    if (user?.type === 'GRAPHIC') {
      window.location.reload()
    }
  }, [account, user, navigation])

  const handleSignIn = async (event: FormEvent) => {
    event.preventDefault()

    if (!document || !password) {
      return
    }

    try {
      setLoading(true)
      setError('')
      await signIn({
        document: document.replace(/[/,.,-\s]/g, ''),
        password,
      })

      setLoading(false)
      setError('')
      navigation('/')
    } catch (err) {
      const error = parseError(err)
      setLoading(false)
      setError('')

      console.log(err)

      setError('Usuário e/ou senha inválido.')
    }
  }

  const handleGoBack = async () => {
    if (isKeyboardVisible) {
      setKeyboardVisible(false)
    }
  }

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 720)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => {
      window.removeEventListener('resize', checkMobile)
    }
  }, [])

  if (isMobile) {
    return (
      <div
        className="w-screen h-screen  bg-cover bg-center "
        style={{
          backgroundImage: `url('${backgroundMobile}')`,
        }}
      >
        <div className="w-full h-full bg-black bg-opacity-60 flex flex-col gap-10 justify-center items-center p-8">
          <img alt="logo" src={logo} className="w-[180px] object-contain" />
          <h1 className="text-lg text-center font-semibold text-white ">
            Tudo está funcionando corretamente! Porém, para acessar sua conta, é
            necessário utilizar um desktop ou laptop.
          </h1>
        </div>
      </div>
    )
  }

  return (
    <div
      className="h-screen relative flex flex-row justify-between gap-5 "
      style={{
        backgroundImage: `url(${background})
		  `,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}
    >
      <div className="flex flex-col absolute bottom-10 left-10">
        <span className="text-white text-xl font-bold">Baixe o nosso app,</span>
        <span className="text-white text-xl">
          disponível nas principais lojas
        </span>
        <div className="flex gap-2 mt-2">
          <img
            alt=""
            src={android}
            className="w-[150px] object-contain cursor-pointer"
          />
          <img
            alt=""
            src={appStore}
            className="w-[150px] object-contain cursor-pointer"
          />
        </div>
      </div>
      <div className="flex-1 flex flex-col justify-center items-end">
        {!isKeyboardVisible && (
          <div
            style={{
              backgroundImage: `url(${background2})
          `,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center center',
            }}
            className="flex flex-col w-full h-full items-center bg-zinc-50 justify-center max-w-[35%] p-20"
          >
            <img
              alt=""
              src={logoBlack}
              className="w-[150px] object-contain mb-10"
            />
            <div className="flex flex-col gap-2 mb-8">
              <span className="font-bold text-3xl text-zinc-900">
                Queremos te proporcionar a melhor experiência!
              </span>
              <span className="font-medium text-xl text-zinc-900">
                Aproveite as nossas vantagens, seja no APP ou no Computador.
              </span>
            </div>
            <img
              alt=""
              src={loginBlocks}
              className="w-[100%] object-contain mb-10"
            />

            <button
              type="button"
              className="bg-[#131313] h-[60px] text-white text-xl font-semibold sigin-button rounded-xl mb-4"
              onClick={() => setKeyboardVisible(true)}
            >
              Entrar
            </button>
            <button
              type="button"
              className="bg-white border-2 border-zinc-400 h-[60px] text-black text-xl font-semibold sigin-button rounded-xl mb-4"
              onClick={() => navigation('/create-account-wallet')}
            >
              Abrir uma conta
            </button>
            <div className="text-center mb-4">
              <a
                href="/forgot"
                className="text-black text-lg p-text hover:underline"
              >
                Esqueceu sua senha?
              </a>
            </div>
          </div>
        )}

        {isKeyboardVisible && (
          <SignInForm back={() => setKeyboardVisible(false)} />
        )}

        {error && (
          <div
            className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mt-4"
            role="alert"
          >
            <p>{error}</p>
          </div>
        )}
      </div>
    </div>
  )
}
